export enum RideStatusEnum {
  PENDING_ACCEPT = "pending-accept",
  PENDING_ARRIVAL = "pending-arrival",
  RIDE_STARTED = "ride-started",
  PENDING_OTP = "pending-otp",
  PENDING_PAYMENT = "pending-payment",
  PAYMENT_FAILED = "payment-failed",
  WAIT_FOR_DRIVER = "wait-for-driver",
  CANCELLED = "cancelled",
  COMPLETED = "completed",
  SCHEDULED = "Scheduled",
  SEARCHING_DRIVER = "searching-driver",
}

export enum RiderStatusEnum {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export enum DriverStatusEnum {
  ONLINE = "online",
  ON_RIDE = "on-ride",
  OFFLINE = "offline",
  ACTIVE = "active",
  INACTIVE = "inactive",
  PENDING = "pending",
}

export enum UserTypeEnum {
  DRIVER = "driver",
  RIDER = "rider",
}

export enum PaymentMode {
  ONLINE = "online",
  CASH = "cash",
  CARD_MACHINE = "card_machine",
}

export enum ApprovalStatus {
  APPROVED = "approved",
  PENDING = "pending",
  REJECTED = "rejected",
}

export enum VehicleStatus {
  AVAILABLE = "available",
  UNAVAILABLE = "unavailable",
}

export enum TransactionOperation {
  IN = 'in',
  OUT = 'out',
  REFUND = 'refund',
}

export enum TransactionType {
  BALANCE = 'balance',
  WALLET = 'wallet',
}

export enum CountryDialCodeEnum {
  BR = "+55",
  FR = "+33",
  KZ = "+77",
}

export enum MobilePhoneLocaleEnum {
  BR = "pt-BR",
  FR = "fr-FR",
  KZ = "kk-KZ",
}

export enum ValidationErrorKeyEnum {
  INVALID_REQUEST = "InvalidRequest",
  VALIDATION_FAILED = "InvalidRequest",
  MOBILE_NUMBER_INVALID = "login.mobileNumberInvalid",
  OTP_INVALID = "errors.invalidOtp",
  USER_TYPE_INVALID = "InvalidRequest",
}

export enum AuthErrorKeyEnum {
  DRIVER_MOBILE_NOT_REGISTERED = "Please enter a registered mobile number.",
}

export enum AdminRoleEnum {
  SUPER_ADMIN = "super_admin",
  ADMIN = "admin",
  MODERATOR = "moderator",
  SUPPORT = "support",
  ANALYST = "analyst",
}

export enum AdminEntityStatusEnum {
  ACTIVE = "active",
  INACTIVE = "inactive",
  BLOCKED = "blocked",
  PENDING = "pending",
}

export enum AdminRideStatusEnum {
  PENDING = "pending",
  ACCEPTED = "accepted",
  STARTED = "started",
  COMPLETED = "completed",
  CANCELLED = "cancelled",
}

export enum AdminVehicleStatusEnum {
  ACTIVE = "active",
  INACTIVE = "inactive",
  MAINTENANCE = "maintenance",
}

export enum AdminAppConfigTypeEnum {
  STRING = "string",
  NUMBER = "number",
  BOOLEAN = "boolean",
  JSON = "json",
}

export enum AdminNotificationTypeEnum {
  INFO = "info",
  WARNING = "warning",
  ERROR = "error",
  SUCCESS = "success",
}

export enum AdminNotificationTargetEnum {
  ALL = "all",
  DRIVERS = "drivers",
  RIDERS = "riders",
  SPECIFIC = "specific",
}

export enum AdminReportTypeEnum {
  RIDES = "rides",
  REVENUE = "revenue",
  DRIVERS = "drivers",
  RIDERS = "riders",
  VEHICLES = "vehicles",
}

export enum AdminReportPeriodEnum {
  DAILY = "daily",
  WEEKLY = "weekly",
  MONTHLY = "monthly",
  YEARLY = "yearly",
  CUSTOM = "custom",
}

export enum AdminReportFormatEnum {
  JSON = "json",
  CSV = "csv",
  PDF = "pdf",
}

export enum AdminBulkOperationEnum {
  UPDATE = "update",
  DELETE = "delete",
  ACTIVATE = "activate",
  DEACTIVATE = "deactivate",
}

export enum AdminBulkEntityTypeEnum {
  DRIVERS = "drivers",
  RIDERS = "riders",
  VEHICLES = "vehicles",
  RIDES = "rides",
}

export enum AdminRealtimeUpdateEnum {
  RIDE_UPDATE = "ride_update",
  DRIVER_STATUS = "driver_status",
  NEW_REGISTRATION = "new_registration",
  SYSTEM_ALERT = "system_alert",
}

export enum AdminFileCategoryEnum {
  PROFILE = "profile",
  DOCUMENT = "document",
  VEHICLE = "vehicle",
  CATEGORY = "category",
  OTHER = "other",
}

export enum RideFilterEnum {
  ALL = "all",
  CURRENT_RIDES = "current-rides",
  COMPLETED = "completed",
  CANCELLED = "cancelled",
  HAS_DISPUTE = "has-dispute",
}

export type JsonValue =
  | string
  | number
  | boolean
  | null
  | JsonValue[]
  | { [key: string]: JsonValue };

export enum OpenAIModelEnum {
  GPT_3_5_TURBO = "gpt-3.5-turbo",
  GPT_4 = "gpt-4",
}

export enum WeatherConditionEnum {
  UNKNOWN = "unknown",
  SUNNY = "sunny",
  RAINY = "rainy",
  CLOUDY = "cloudy",
}

export enum TrafficLevelEnum {
  UNKNOWN = "unknown",
  LOW = "low",
  MEDIUM = "medium",
  HIGH = "high",
}

export enum DemandLevelEnum {
  NORMAL = "normal",
  ELEVATED = "elevated",
  HIGH = "high",
  VERY_HIGH = "very_high",
}

export enum SystemVehicleType {
  AIRPLANE = 'airplane',
  HELICOPTER = 'helicopter',
  TRUCK = 'truck',
  TRAILER = 'trailer',
  BUS = 'bus',
  CAR = 'car',
  MOTORCYCLE = 'motorcycle',
  BIKE = 'bike',
  WALKING = 'walking',
}

export enum TransportMode {
  PERSON = 'person',
  CARGO = 'cargo',
}
